import React from 'react'
import xss from 'xss'

interface DynamicStyleProps {
  namespace?: string
  children: React.ReactNode
}

export const DynamicStyle: React.FC<DynamicStyleProps> = ({children, namespace}) => {
  let styles = children.toString()

  if (namespace) {
    styles = styles.replace(/^\s*\./gm, `.${namespace} .`)
    styles = styles.replace(/^\s*&\./gm, `.${namespace}.`)
    styles = styles.replace(/\$namespace\$/gm, `.${namespace}`)
  }

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: xss(styles),
      }}
    />
  )
}
